<template>
    <ContentPage title="Polityka prywatności" sub-title="Zgodnie z artykułem 13 Rozporządzenia (UE) 2016/679">
        <p>
            Adorea S.r.l. („Adorea S.r.l. (Fleequid)”), z siedzibą w Olgiate Comasco (CO) 22077, Via provinciale per Bizzarone, 43, NIP i numer
            identyfikacji podatkowej 04114790134, zarejestrowana w Rejestrze Przedsiębiorstw w Como pod numerem 04114790134, z w pełni opłaconym
            kapitałem zakładowym w wysokości 10.000,00 € („<strong>Adorea S.r.l. (Fleequid)</strong>”) jako administrator danych, niniejszym wydaje tę
            informację dotyczącą przetwarzania Twoich danych osobowych zgodnie z art. 13 Rozporządzenia (UE) nr 2016/679 („<strong>RODO</strong>”).
        </p>

        <BaseVerticalStack as="ol" class="list-inside list-decimal">
            <li>
                <h3 class="text-highlighted inline-block font-bold">Cel przetwarzania i podstawa prawna</h3>
                <p class="my-4">
                    Adorea S.r.l. (Fleequid) specjalizuje się w prowadzeniu aukcji internetowych pojazdów przemysłowych, dedykowanych wyłącznie
                    klientom biznesowym. Podczas rejestracji firmy na platformie Adorea S.r.l. (Fleequid) w celu udziału w aukcji, wymagane jest
                    podanie danych osoby kontaktowej, tj. imię, nazwisko, adres e-mail oraz numer telefonu („<strong>Dane</strong>”). Dane te będą
                    przetwarzane przez Adorea S.r.l. (Fleequid), również w formie elektronicznej/cyfrowej, wyłącznie w następujących celach i na
                    następującej podstawie prawnej:
                </p>
                <div class="my-4 grid grid-cols-[40px_1fr_1fr] grid-rows-[24px_1fr_1fr] gap-2">
                    <div class="font-bold">Nr</div>
                    <div class="font-bold">Cel</div>
                    <div class="font-bold">Podstawa prawna</div>
                    <div class="font-bold">1.1</div>
                    <div>
                        Umożliwienie udziału użytkownika w aukcji na jego żądanie, zapewnienie prawidłowego przebiegu aukcji oraz możliwość kontaktu z
                        wyznaczonym przedstawicielem firmy w przypadku wygrania licytacji
                    </div>
                    <div>Realizacja umowy</div>
                    <div class="font-bold">1.2</div>
                    <div>Wysyłanie materiałów informacyjnych dotyczących usług oferowanych przez Adorea S.r.l. (Fleequid)</div>
                    <div>
                        Na podstawie art. 130 ust. 4 Dekretu Legislacyjnego nr 196/2003, przetwarzanie opiera się na uzasadnionym interesie. Osoba,
                        której dane dotyczą, ma prawo w każdej chwili, bezpłatnie i w prosty sposób, sprzeciwić się przetwarzaniu.
                    </div>
                </div>
                <p class="my-4">
                    Podanie danych osobowych jest niezbędne do udziału w aukcji i korzystania z usług Adorea S.r.l. (Fleequid). Brak podania tych
                    danych uniemożliwia udział i zawarcie umowy z Adorea S.r.l. (Fleequid).
                </p>
            </li>

            <li>
                <h3 class="text-highlighted inline-block font-bold">Przekazywanie i transfer danych</h3>
                <p class="my-4">
                    Dane mogą być również przetwarzane przez podmioty współpracujące, które wykonują czynności związane, wspierające lub niezbędne dla
                    działalności Adorea S.r.l. (Fleequid), działające jako podmioty przetwarzające na podstawie instrukcji Adorea S.r.l. (Fleequid). W
                    przypadku przekazania danych do krajów spoza Europejskiego Obszaru Gospodarczego, Adorea S.r.l. (Fleequid) zapewnia zgodność z
                    polityką prywatności oraz obowiązującymi przepisami o ochronie danych.
                </p>
            </li>

            <li>
                <h3 class="text-highlighted inline-block font-bold">Okres przechowywania danych</h3>
                <p class="my-4">
                    Twoje dane będą przechowywane przez minimalny okres niezbędny do realizacji celów określonych w punkcie 1 powyżej, tj. przez 10
                    lat od zakończenia skutków umowy. Okres ten jest uzasadniony, zwłaszcza w celach marketingowych, ze względu na specjalistyczny
                    charakter towarów będących przedmiotem aukcji prowadzonych przez Adorea S.r.l. (Fleequid), tj. pojazdów przemysłowych o wysokiej
                    wartości. Po upływie tego okresu dane zostaną usunięte lub zanonimizowane.
                </p>
            </li>

            <li>
                <h3 class="text-highlighted inline-block font-bold">Prawa osoby, której dane dotyczą</h3>
                <p class="my-4">
                    Osobie, której dane dotyczą, przysługują następujące prawa: dostęp do swoich danych oraz informacji o celu przetwarzania,
                    kategoriach danych osobowych, odbiorcach lub kategoriach odbiorców, którym dane mogą być ujawnione, oraz okresie przechowywania
                    danych (art. 15 RODO); sprostowanie nieprawidłowych danych (art. 16 RODO); żądanie usunięcia danych (art. 17 RODO); ograniczenie
                    przetwarzania (art. 18 RODO); przenoszenie danych (art. 20 RODO); prawo sprzeciwu wobec przetwarzania, w tym w celach
                    marketingowych (art. 21 RODO).
                </p>
                <p class="my-4">
                    W przypadku chęci złożenia skargi do organu nadzorczego ds. ochrony danych, można to zrobić zgodnie z procedurami opisanymi na
                    <NuxtLink class="text-primary hover:underline" to="https://www.garanteprivacy.it" target="_blank" external>
                        www.garanteprivacy.it</NuxtLink
                    >.
                </p>
                <p class="my-4">
                    Wszelkie pytania lub wątpliwości dotyczące naszej polityki prywatności prosimy kierować na adres
                    <FleequidEmailLink type="privacy" />. Na wszystkie zgłoszenia dotyczące realizacji praw w zakresie ochrony danych odpowiadamy
                    niezwłocznie, zgodnie z obowiązującymi przepisami.
                </p>
            </li>
        </BaseVerticalStack>
    </ContentPage>
</template>
